import React, {useMemo} from 'react';
import moment from "moment";

const CreationDataCell = ({value}) => {

    const formattedDate = useMemo(() =>
            moment(value).format('DD-MMM-YYYY, HH:mm')
        , [value]);

    return (
        <div>
            {formattedDate}
        </div>
    );
};
export default CreationDataCell;
